import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { slice } from 'state/app/slice';
import selectors from 'state/selectors';
import { CommonButton } from 'components/Buttons';
import utils from 'utils';

const ToggleExpander: React.FC = () => {
  const dispatch = useDispatch();
  const isExpanded = useSelector(selectors.app.getHeaderExpanded);

  const handleToggle = () => {
    dispatch(slice.actions.toggleHeader());
  };
  const t = utils.intl.useTranslator();

  return (
    <CommonButton
      id="toggle-expander-btn"
      action={handleToggle}
      scope="tertiary"
      value={isExpanded ? t('collapse-header') : t('expand-header')}
      customIcon={isExpanded ? 'angle-up' : 'angle-down'}
    />
  );
};

export default ToggleExpander;
